import { useState } from "react";
import {
  getOffersApi,
  addOfferApi,
  updateOfferApi,
  deleteOfferApi,
} from "../api/offer";
import { useAuth } from "./";

export function useOffer() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [offers, setOffers] = useState(null);
  const { auth } = useAuth();

  const getOffers = async (onlyActive = false) => {
    try {
      setLoading(true);
      const response = await getOffersApi(onlyActive);
      setLoading(false);
      setOffers(response);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const addOffer = async (data) => {
    try {
      setLoading(true);
      await addOfferApi(data, auth.token);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const updateOffer = async (id, data) => {
    try {
      setLoading(true);
      await updateOfferApi(id, data, auth.token);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const deleteOffer = async (id) => {
    try {
      setLoading(true);
      await deleteOfferApi(id, auth.token);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  return {
    loading,
    error,
    offers,
    getOffers,
    addOffer,
    updateOffer,
    deleteOffer,
  };
}
